'use client';

import { Checkbox } from '@/lib/ui-kit-v2/checkbox';

interface CommentsCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const CommentsCheckbox = ({ checked, onChange, label }: CommentsCheckboxProps) => {
  return (
    <Checkbox
      label={
        <span className="whitespace-nowrap text-[13px] font-normal leading-[150%] tracking-[-0.01em] text-v2-text-primary">
          {label}
        </span>
      }
      checked={checked}
      onCheckedChange={(value) => onChange(Boolean(value))}
    />
  );
};
